import React, { useState, useEffect } from "react";
import "./menu.css";
import { getFilteredMenu } from "./menuPermissions";

export const gestionDeAlmacenMenu = [
  // Nivel principal: Cajas
  {
    title: "Cajas",
    icono: "Dashboard.svg",
    enlace: "#",
    activo: "gestión_de_almacén/cajas",
    permiso: [4058, 4059, 4060, 4061, 4062], // Rango original: 4058 a 4062
    hijos: [
      {
        title: "Caja principal",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout/principal')
        activo: "gestión_de_almacén/cajas/caja_principal",
        permiso: [4058],
      },
      {
        title: "Devoluciones",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout_refunds')
        activo: "gestión_de_almacén/cajas/devoluciones",
        permiso: [4059],
      },
      {
        title: "Tómbola",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout.money_container')
        activo: "gestión_de_almacén/cajas/tombola",
        permiso: [4060],
      },
      {
        title: "Estado de cuenta",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout_payment/bank_statement')
        activo: "gestión_de_almacén/cajas/estado_de_cuenta",
        permiso: [4061],
      },
      {
        title: "Validación de transferencia",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout_transfer_validation')
        activo: "gestión_de_almacén/cajas/validacion_de_transfer",
        permiso: [4062],
      },
    ],
  },

  // Nivel principal: Reportes de Ingresos
  {
    title: "Reportes de Ingresos",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/reportes_de_ingresos",
    permiso: [4002, 4003, 4004, 4005, 4006, 4007, 4008], // Rango original: 4002 a 4008
    hijos: [
      // Nivel 2: ALFI Financiero
      {
        title: "ALFI Financiero",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "gestión_de_almacén/reportes_de_ingresos/ALFI_financiero",
        permiso: [4002, 4003], // Rango original: 4002 a 4003
        hijos: [
          {
            title: "ALFI Importación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.alfi_financial')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ALFI_financiero/ALFI_importación",
            permiso: [4002],
          },
          {
            title: "ALFI Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.alfi_financial_export')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ALFI_financiero/ALFI_exportación",
            permiso: [4003],
          },
        ],
      },
      // Nivel 2: Ingresos por Concepto
      {
        title: "Ingresos por Concepto",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto",
        permiso: [4004, 4005, 4006, 4007, 4008], // Rango original: 4004 a 4008
        hijos: [
          {
            title: "Ingresos por concepto Importación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.incomes')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_concepto_importación",
            permiso: [4004],
          },
          {
            title: "Ingresos por concepto Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.income_expo')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_concepto_exportación",
            permiso: [4005],
          },
          {
            title: "Ingresos por cliente Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.rev_custom_expo')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_cliente_exportación",
            permiso: [4006],
          },
          {
            title: "Anual Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.anual_export')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/anual_exportación",
            permiso: [4007],
          },
          {
            title: "Toneladas totales por día Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.tons_expo')
            activo:
              "gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/toneladas_totales_por_dia_exportación",
            permiso: [4008],
          },
        ],
      },
    ],
  },

  // Nivel principal: Reportes Operativos
  {
    title: "Reportes Operativos",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/reportes_operativos",
    permiso: [4009, 4010, 4011, 4012, 4013], // Rango original: 4009 a 4013
    hijos: [
      // Nivel 2: ALFI Operativo
      {
        title: "ALFI Operativo",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "gestión_de_almacén/reportes_operativos/ALFI_operativo",
        permiso: [4009, 4010, 4011], // Rango original: 4009 a 4011
        hijos: [
          {
            title: "ALFI Importación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.operational_alfi')
            activo:
              "gestión_de_almacén/reportes_operativos/ALFI_operativo/ALFI_importación",
            permiso: [4009],
          },
          {
            title: "ALFI Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.operational_alfi_exp')
            activo:
              "gestión_de_almacén/reportes_operativos/ALFI_operativo/ALFI_exportación",
            permiso: [4010],
          },
          {
            title: "Toneladas mensuales",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.alfi')
            activo:
              "gestión_de_almacén/reportes_operativos/ALFI_operativo/toneladas_mensuales",
            permiso: [4011],
          },
        ],
      },
      // Nivel 2: Incidencias
      {
        title: "Incidencias",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.nincidents')
        activo: "gestión_de_almacén/reportes_operativos/incidencias",
        permiso: [4012],
      },
      // Nivel 2: Locaciones
      {
        title: "Locaciones",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('warehouses.locations')
        activo: "gestión_de_almacén/reportes_operativos/locaciones",
        permiso: [4013],
      },
      {
        title: "Inventario de abandonos",
        icono: "Dashboard.svg",
        enlace: "InvAbandonosReport", // Modificado de URL::route('warehouses.InvAbandonosReport')
        activo: "gestión_de_almacén/reportes_operativos/inventario_de_abandonos",
        permiso: [4069],
      },
    ],
  },

  // Nivel principal: Abandonos
  {
    title: "Abandonos",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/abandonos",
    permiso: [4014, 4015, 4016, 4017, 4018, 4019], // Rango original: 4014 a 4019
    hijos: [
      {
        title: "Listado",
        icono: "Dashboard.svg",
        enlace: "Listing", // Modificado de URL::route('abandonments')
        activo: "gestión_de_almacén/abandonos/listado",
        permiso: [4014],
      },
      {
        title: "Acuses",
        icono: "Dashboard.svg",
        enlace: "Acuses", // Modificado de URL::route('abandonments.replies')
        activo: "gestión_de_almacén/abandonos/acuses",
        permiso: [4015],
      },
      {
        title: "Previos",
        icono: "Dashboard.svg",
        enlace: "Previos", // Modificado de URL::route('abandonments.preves')
        activo: "gestión_de_almacén/abandonos/previos",
        permiso: [4016],
      },
      {
        title: "Clasificación SAT",
        icono: "Dashboard.svg",
        enlace: "ClasificacionSat", // Modificado de URL::route('abandonments.classifications')
        activo: "gestión_de_almacén/abandonos/clasificación_SAT",
        permiso: [4017],
      },
      {
        title: "Salidas",
        icono: "Dashboard.svg",
        enlace: "Salidas", // Modificado de URL::route('abandonments.departures')
        activo: "gestión_de_almacén/abandonos/salidas",
        permiso: [4018],
      },
      {
        title: "Cálculo de abandono",
        icono: "Dashboard.svg",
        enlace: "CalculoAbandonos", // Modificado de URL::route('reports.abandonments')
        activo: "gestión_de_almacén/abandonos/cálculo_de_abandono",
        permiso: [4019],
      },
    ],
  },

  // Nivel principal: Cumplimiento Aduanal
  {
    title: "Cumplimiento Aduanal",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/aduana_cumplimiento_aduanal",
    permiso: [4020, 4021, 4022, 4023, 4024, 4025], // Rango original: 4020 a 4025
    hijos: [
      {
        title: "Conectividad SAT",
        icono: "Dashboard.svg",
        enlace: "ConectividadSat", // Modificado de URL::route('connectivity')
        activo:
          "gestión_de_almacén/aduana_cumplimiento_aduanal/conectividad_SAT",
        permiso: [4020],
      },
      {
        title: "Puntos Tácticos",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('tacticals.create')
        activo:
          "gestión_de_almacén/aduana_cumplimiento_aduanal/puntos_tácticos",
        permiso: [4021],
      },
      {
        title: "PAMAS",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.pamas')
        activo: "gestión_de_almacén/aduana_cumplimiento_aduanal/PAMAS",
        permiso: [4022],
      },
      {
        title: "Valor Promedio",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.average_value')
        activo: "gestión_de_almacén/aduana_cumplimiento_aduanal/valor_promedio",
        permiso: [4023],
      },
      {
        title: "Valor Aduana",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.custom_value')
        activo: "gestión_de_almacén/aduana_cumplimiento_aduanal/valor_aduana",
        permiso: [4024],
      },
      {
        title: "Estrados",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.fiscal')
        activo: "gestión_de_almacén/aduana_cumplimiento_aduanal/estrados",
        permiso: [4025],
      },
    ],
  },

  // Nivel principal: Tarifas
  {
    title: "Tarifas",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/tarifas",
    permiso: [4026, 4027, 4028, 4029, 4030, 4031, 4032, 4033], // Rango original: 4026 a 4033
    hijos: [
      {
        title: "Tarifario Importación",
        icono: "Dashboard.svg",
        enlace: "ImpoTariff", // Modificado de URL::route('ratecard_impo')
        activo: "gestión_de_almacén/tarifas/tarifario_importación",
        permiso: [4026],
      },
      {
        title: "Tarifario Exportación",
        icono: "Dashboard.svg",
        enlace: "ExpoTariff", // Modificado de URL::route('ratecard_expo')
        activo: "gestión_de_almacén/tarifas/tarifario_exportación",
        permiso: [4027],
      },
      {
        title: "Excepciones Importación",
        icono: "Dashboard.svg",
        enlace: "ExceptionsImpo", // Modificado de URL::route('exceptions')
        activo: "gestión_de_almacén/tarifas/excepciones_importación",
        permiso: [4028],
      },
      {
        title: "Reglas Comerciales Importación",
        icono: "Dashboard.svg",
        enlace: "TradingRules", // Modificado de URL::route('exceptions.client')
        activo: "gestión_de_almacén/tarifas/reglas_comerciales_importación",
        permiso: [4029],
      },
      {
        title: "Excepciones Exportación",
        icono: "Dashboard.svg",
        enlace: "Exceptions", // Modificado de URL::route('export.exceptions')
        activo: "gestión_de_almacén/tarifas/excepciones_exportación",
        permiso: [4030],
      },
      {
        title: "Reglas Comerciales Exportación",
        icono: "Dashboard.svg",
        enlace: "TradeRules",
        activo: "gestión_de_almacén/tarifas/reglas_comerciales_exportación",
        permiso: [4031],
      },
      {
        title: "Folios 0 Eliminados",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.deleted_folio_zero')
        activo: "gestión_de_almacén/tarifas/folios_0_eliminados",
        permiso: [4032],
      },
      {
        title: "Tipo de cambio",
        icono: "Dashboard.svg",
        enlace: "ExchangeRate", // Modificado de URL::route('exchange_rate')
        activo: "gestión_de_almacén/tarifas/tipo_de_cambio",
        permiso: [4033],
      },
    ],
  },

  // Nivel principal: Catálogos
  {
    title: "Catálogos",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/catálogos",
    permiso: [
      4034, 4035, 4036, 4037, 4038, 4039, 4040, 4041, 4042, 4043, 4044, 4045,
      4046, 4047, 4048, 4049, 4050
    ], // Rango original: 4034 a 4050
    hijos: [
      {
        title: "Remit. / Consig.",
        icono: "Dashboard.svg",
        enlace: "RemitentesConsignatarios", // Modificado de URL::route('catalogs.shipper-consignee')
        activo: "gestión_de_almacén/catálogos/remit._consig.",
        permiso: [4034],
      },
      {
        title: "Agentes",
        icono: "Dashboard.svg",
        enlace: "Agents", // Modificado de URL::route('catalogs.agents')
        activo: "gestión_de_almacén/catálogos/agentes",
        permiso: [4035],
      },
      {
        title: "Clientes",
        icono: "Dashboard.svg",
        enlace: "Clients", // Modificado de URL::route('catalogs.clients')
        activo: "gestión_de_almacén/catálogos/clientes",
        permiso: [4036],
      },
      {
        title: "Clientes Expo",
        icono: "Dashboard.svg",
        enlace: "ClientsExpo", // Modificado de URL::route('catalogs.clients_export')
        activo: "gestión_de_almacén/catálogos/clientes_expo",
        permiso: [4037],
      },
      {
        title: "CFDI",
        icono: "Dashboard.svg",
        enlace: "CFDITypes", // Modificado de URL::route('catalogs.cfdi_types')
        activo: "gestión_de_almacén/catálogos/CFDI",
        permiso: [4038],
      },
      {
        title: "Cond. De pago",
        icono: "Dashboard.svg",
        enlace: "PaymentConditions", // Modificado de URL::route('catalogs.c_payment_conditions')
        activo: "gestión_de_almacén/catálogos/cond_de_pago",
        permiso: [4039],
      },
      {
        title: "Tipos de pago",
        icono: "Dashboard.svg",
        enlace: "PaymentTypes", // Modificado de URL::route('catalogs.c_payment_types')
        activo: "gestión_de_almacén/catálogos/tipos_de_pago",
        permiso: [4040],
      },
      {
        title: "Tarimas",
        icono: "Dashboard.svg",
        enlace: "Tarimas", // Modificado de URL::route('catalogs.pallets')
        activo: "gestión_de_almacén/catálogos/tarimas",
        permiso: [4041],
      },
      {
        title: "Montacarguistas",
        icono: "Dashboard.svg",
        enlace: "LiftTrucks", // Modificado de URL::route('catalogs.lift-trucks')
        activo: "gestión_de_almacén/catálogos/montacarguistas",
        permiso: [4042],
      },
      {
        title: "Irregularidades",
        icono: "Dashboard.svg",
        enlace: "Irregularity", // Modificado de URL::route('catalogs.irregularity_types')
        activo: "gestión_de_almacén/catálogos/irregularidades",
        permiso: [4043],
      },
      {
        title: "Instituciones",
        icono: "Dashboard.svg",
        enlace: "Institutions", // Modificado de URL::route('catalogs.c_institutions')
        activo: "gestión_de_almacén/catálogos/instituciones",
        permiso: [4044],
      },
      {
        title: "Almacenes",
        icono: "Dashboard.svg",
        enlace: "Warehouses", // Modificado de URL::route('catalogs.iwarehouses')
        activo: "gestión_de_almacén/catálogos/almacenes",
        permiso: [4045],
      },
      {
        title: "Alm. Externos dest",
        icono: "Dashboard.svg",
        enlace: "ExternalDesWarehouses", // Modificado de URL::route('catalogs.external_warehouses')
        activo: "gestión_de_almacén/catálogos/alm._externos",
        permiso: [4046],
      },
      {
        title: "Usuarios Cooler",
        icono: "Dashboard.svg",
        enlace: "CoolerUsers", // Modificado de URL::route('catalogs.cooler-users')
        activo: "gestión_de_almacén/catálogos/usuarios_cooler",
        permiso: [4047],
      },
      {
        title: "Usuarios",
        icono: "Dashboard.svg",
        enlace: "Users", // Modificado de URL::route('users')
        activo: "gestión_de_almacén/catálogos/usuarios",
        permiso: [4048],
      },
      {
        title: "Perfil de Usuarios",
        icono: "Dashboard.svg",
        enlace: "PerfilesUsuario", // Modificado de URL::route('user_profiles')
        activo: "gestión_de_almacén/catálogos/perfil_de_usuarios",
        permiso: [4049],
      },
      {
        title: "Exp. Contraseña",
        icono: "Dashboard.svg",
        enlace: "PasswordExp", // Modificado de URL::route('password_expirations')
        activo: "gestión_de_almacén/catálogos/exp._contraseña",
        permiso: [4050],
      },
    ],
  },

  // Nivel principal: Control Sistemas
  {
    title: "Control Sistemas",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/control_sistemas",
    permiso: [4051, 4052, 4053, 4054, 4055], // Rango original: 4051 a 4055
    hijos: [
      {
        title: "Ventana Mantenimiento",
        icono: "Dashboard.svg",
        enlace: "MaintenanceWindow", // Modificado de URL::route('maintenance_windows')
        activo: "gestión_de_almacén/control_sistemas/ventana_mantenimiento",
        permiso: [4051],
      },
      {
        title: "FTP Cubiscan",
        icono: "Dashboard.svg",
        enlace: "FTPCubiscan", // Modificado de URL::route('pass_ftp_cubiscan')
        activo: "gestión_de_almacén/control_sistemas/FTP_cubiscan",
        permiso: [4052],
      },
      {
        title: "Logs Oracle",
        icono: "Dashboard.svg",
        enlace: "LogsOracle", // Modificado de URL::route('oracle_logs')
        activo: "gestión_de_almacén/control_sistemas/logs_oracle",
        permiso: [4053],
      },
      {
        title: "Error Logs",
        icono: "Dashboard.svg",
        enlace: "ErrorLogs", // Modificado de URL::route('error_logs')
        activo: "gestión_de_almacén/control_sistemas/erros_logs",
        permiso: [4054],
      },
      {
        title: "Pin Montacarga",
        icono: "Dashboard.svg",
        enlace: "PinLift",
        activo: "gestión_de_almacén/control_sistemas/pin_montacarga",
        permiso: [4055],
      },
      {
        title: "Estado Cubiscan",
        icono: "Dashboard.svg",
        enlace: "#",
        activo: "gestión_de_almacén/control_sistemas/estado_cubiscan",
        permiso: [],
        indicator: true,
      },
    ],
  },

  // Nivel principal: Notificaciones
  {
    title: "Notificaciones",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "gestión_de_almacén/notificaciones",
    permiso: [4056, 4057], // Rango original: 4056 a 4057
    hijos: [
      {
        title: "Servicios",
        icono: "Dashboard.svg",
        enlace: "Services", // Modificado de URL::route('notification_services')
        activo: "gestión_de_almacén/notificaciones/servicios",
        permiso: [4056],
      },
      {
        title: "SLA",
        icono: "Dashboard.svg",
        enlace: "SLA", // Modificado de URL::route('notification_slas')
        activo: "gestión_de_almacén/notificaciones/SLA",
        permiso: [4057],
      },
    ],
  },
];

export const getGestionDeAlmacenMenu = () =>
  getFilteredMenu(gestionDeAlmacenMenu);

const MenuItem = ({
  item,
  activePath,
  onSetActive,
  onHoverChange,
  hoveredItem,
  onComponentChange,
  statusValue,
  onCubiscanRequest,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.hijos && item.hijos.length > 0;

  // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
  const currentPath = activePath || "";

  // Lógica para determinar el resaltado
  const isCurrentActive = item.activo === currentPath;
  const isAncestorActive =
    currentPath.startsWith(item.activo + "/") && !isCurrentActive;

  // Colapso automático/apertura si es parte del path activo
  useEffect(() => {
    if (isAncestorActive || isCurrentActive) {
      setIsOpen(true);
    }
  }, [isAncestorActive, isCurrentActive]);

  // Lógica de Hover (se mantiene)
  const isHighlighted = item.title === hoveredItem;
  const hoverProps = hasChildren
    ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
      }
    : {};

  // Si el item es un indicador estático, no debe ser interactivo
  if (item.indicator) {
    const isGreen = Number(statusValue) === 1;
    const circleStyle = {
      display: "inline-block",
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      backgroundColor: isGreen ? "#28a745" : "#dc3545",
      marginLeft: "8px",
    };

    return (
      <li className={`menu-item ${item.activo}`}>
        <div
          className="menu-link text-white px-3 d-flex justify-content-between align-items-center"
          style={{ cursor: "default" }}
        >
          <span>{item.title}</span>
          <span style={circleStyle} aria-hidden="true" />
        </div>
      </li>
    );
  }

  // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
  const handleItemClick = (e) => {
    // 1. Lógica de Colapso (Si tiene hijos)
    if (hasChildren) {
      e.preventDefault();
      const newOpen = !isOpen;
      setIsOpen(newOpen);

      // Si se abrió el submenú de 'Control Sistemas', solicita estado de Cubiscan
      if (
        newOpen &&
        (item.activo === "gestión_de_almacén/control_sistemas" ||
          item.title === "Control Sistemas")
      ) {
        if (typeof onCubiscanRequest === "function") onCubiscanRequest();
      }
    }

    // 2. Lógica de Navegación/Selección (Elementos hoja)
    else {
      e.preventDefault();

      if (onComponentChange) {
        sessionStorage.setItem('currentModule', item.enlace !== '#' ? item.enlace : '');
        // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
        onComponentChange(item.enlace, item.activo);
      }

      // onSetActive ya no se llama localmente porque Admin.js lo maneja.
    }
  };

  // Determina las clases de estilo (se mantiene)
  let itemClass = "";
  if (isCurrentActive) {
    itemClass = "is-active";
  } else if (isAncestorActive) {
    itemClass = "is-ancestor";
  }

  return (
    <li
      className={`menu-item ${item.activo} ${itemClass} ${
        isHighlighted ? "highlighted" : ""
      }`}
      {...hoverProps}
    >
      <a
        href={item.enlace}
        onClick={handleItemClick}
        className={`
          menu-link 
          text-white 
          px-3 
          d-flex 
          justify-content-between 
          align-items-center
          ${item.enlace === sessionStorage.getItem("currentModule") ? 'active' : ''}
        `}
      >
        {item.title}
        {hasChildren && <span className="arrow">{isOpen ? "▲" : "▼"}</span>}
      </a>

      {/* Llamada Recursiva: Pasamos todos los props necesarios */}
      {hasChildren && (
        <ul className="submenu" style={{ display: isOpen ? "block" : "none" }}>
          {item.hijos.map((child, index) => (
            <MenuItem
              key={index}
              item={child}
              activePath={activePath}
              onSetActive={onSetActive} // Dummy
              onHoverChange={onHoverChange}
              hoveredItem={hoveredItem}
              onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
              statusValue={statusValue}
              onCubiscanRequest={onCubiscanRequest}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const MenuGestion = ({
  activePath,
  onComponentChange,
  openSignal,
  openParam,
  onCubiscanRequest,
}) => {
  // Estados locales (solo Hover)
  const [hoveredItem, setHoveredItem] = useState(null);
  const menuItems = getGestionDeAlmacenMenu();
  const handleHoverChange = (title) => {
    setHoveredItem(title);
  };

  // Efecto para detectar la señal de apertura enviada desde Admin
  useEffect(() => {
    if (openSignal && typeof openParam !== "undefined") {
      // Ejecuta la función interna con el parámetro recibido (por ejemplo 1)
      handleOpenWithParam(openParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSignal]);

  const handleOpenWithParam = (param) => {
    // Aquí puedes colocar la lógica que deba ejecutarse cuando
    // se abra el menú de gestión. Actualmente sólo registra en consola.
    // Puedes reemplazar esto por la acción que necesites.
  };

  // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
  const handleSetActiveDummy = () => {};

  return (
    <nav className="menu-importacion">
      <ul className="menu-list">
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.title || index}
            item={item}
            activePath={activePath} // <-- Recibido de Admin.js
            onSetActive={handleSetActiveDummy}
            onHoverChange={handleHoverChange}
            hoveredItem={hoveredItem}
            onComponentChange={onComponentChange} // <-- Función enviada al fondo
            statusValue={openParam}
            onCubiscanRequest={onCubiscanRequest}
          />
        ))}
      </ul>
    </nav>
  );
};

export default MenuGestion;
